export default __webpack_public_path__ + "static/media/ArticleV3.c0ac7972.jpg";